import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private readonly skipSpinnerUrls = [
    'ai/analyze-cruise',
    '/trackpoints',
    'generateEditorialBrief',
    'suggestEditorialVisuals',
    'publishEditorialPostToJoomla',
    'syncEditorialPostFromJoomla',
    'syncPublishedEditorialPostsFromJoomla'
  ];

  constructor(private readonly spinnerService: SpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldSkip = this.skipSpinnerUrls.some(url => req.url.includes(url));

    if (shouldSkip) {
      return next.handle(req);
    }

    this.spinnerService.show();

    return next.handle(req).pipe(
      finalize(() => this.spinnerService.hide())
    );
  }
}
